import styled from "styled-components";
import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from 'core/modules';

interface ColorElementProps {
  selected?: boolean;
  color: string,
  currentBackground: string,
  isCompetition?: boolean
}

export const ColorPickerWrapper = styled(FlexBox)`
  flex-wrap: wrap;
  width: 100%;
  margin: 0 -16px -16px 0;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 394px;
  }
`

const geContrastColor = ({ currentBackground, color }: ColorElementProps) => currentBackground === Colors.gal
&& color === Colors.gal
  ? '#000000'
  : Colors.gal;

export const ColorElement = styled.div<ColorElementProps>`
  cursor: pointer;
  height: 32px;
  width: 32px;
  border: 1px solid ${geContrastColor};
  overflow: hidden;
  // clip-path: circle(50%);
  background: #FFFFFF;
  border-radius: 3px;
  margin: ${({isCompetition}) => isCompetition ? '0 10px 12px 0' : '0 8px 8px 0'};
  position: relative;
  
  &:before {
    content: "\\00a0";
    position: absolute;
    height: 100%;
    width: 100%;
    background: ${({ color }) => color};
  }

  &:after {
    content: "\\00a0";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: all 100ms;
    border-radius: 4px;
    height: ${({ selected }) => selected ? '8px' : 0};
    width: ${({ selected }) => selected ? '8px' : 0};
    background: ${geContrastColor};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 28px;
    height: 28px;
    margin: 0 9.8px 12px 0;
  }
`;import styled from "styled-components";
import { Colors, FlexBox } from "@brg/ui";
import { LayoutConst } from 'core/modules';

interface ColorElementProps {
  selected?: boolean;
  color: string,
  currentBackground: string,
  isCompetition?: boolean
}

export const ColorPickerWrapper = styled(FlexBox)`
  flex-wrap: wrap;
  width: 100%;
  margin: 0 -16px -16px 0;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-width: 394px;
  }
`

const geContrastColor = ({ currentBackground, color }: ColorElementProps) => currentBackground === Colors.gal
&& color === Colors.gal
  ? '#000000'
  : Colors.gal;

export const ColorElement = styled.div<ColorElementProps>`
  cursor: pointer;
  height: 32px;
  width: 32px;
  border: 1px solid ${geContrastColor};
  overflow: hidden;
  // clip-path: circle(50%);
  background: #FFFFFF;
  border-radius: 3px;
  margin: ${({isCompetition}) => isCompetition ? '0 10px 12px 0' : '0 8px 8px 0'};
  position: relative;
  
  &:before {
    content: "\\00a0";
    position: absolute;
    height: 100%;
    width: 100%;
    background: ${({ color }) => color};
  }

  &:after {
    content: "\\00a0";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: all 100ms;
    border-radius: 4px;
    height: ${({ selected }) => selected ? '8px' : 0};
    width: ${({ selected }) => selected ? '8px' : 0};
    background: ${geContrastColor};
  }

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 28px;
    height: 28px;
    margin: 0 9.8px 12px 0;
  }
`;